var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.checked ? 'checked': ''},[_c('i'),_c('input',{attrs:{"type":"checkbox"},on:{"change":function($event){return _vm.$emit('change', _vm.id)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }